/**
 * Created by fers on 26.09.15.
 */

import {declareEntity} from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';

export default declareEntity({
    entity: "apiKeys",
    graphQL: "ApiKey",
    name: "API Key",
    parentRelation: 'apiKey',
    dynamoPrefix: 'app',
    storageType: 'central',
    fields: (types) => { return {
        id: {
            name: "ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        apiKey: {
            name: "API Key",
            type: "string",
            defaultValue: () => {
                return uuidv4();
            },
            userEditable: false,
        },
        user: {
            name: "User",
            type: "relation",
            to: () => types['users'],
            defaultValue: (user) => {
                return user['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
        },
        description: {
            name: "Description",
            type: "string",
        },
        validFrom: {
            name: "Valid From",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            }
        },
        validTo: {
            name: "Valid To",
            type: "datetime",
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        author: {
            name: "Created By",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
